import { useState, type FormEvent } from 'react';
import { login } from '../sync/authStore';
import { Window } from '../ui/Window';
import { paths } from './router';

export function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="desktop">
      <Window title="Visual Data Slate · Sign in">
        <form className="form" onSubmit={submit}>
          <label>
            <span>Email</span>
            <input type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus />
          </label>
          <label>
            <span>Password</span>
            <input type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          </label>
          {error && <div className="form-error">{error}</div>}
          <div className="form-actions">
            <button type="submit" className="btn btn-primary" disabled={busy}>
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
            <a className="btn" href={paths.local()}>
              Local scratch board
            </a>
          </div>
          <p className="form-hint">
            Accounts are created by invite. Got a code? <a href={paths.register()}>Register</a>.
          </p>
        </form>
      </Window>
    </main>
  );
}
